module.exports = __webpack_public_path__ + "static/media/amexLogo.d3b02893.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/patient-list/images/amexLogo.svg
// module id = 13719
// module chunks = 0